import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import {
  Box,
  Grid,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { IMedia } from 'interfaces/media.interface';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

type ProductGallerySwiperLightBoxProps = {
  imageSelected?: IMedia | null;
  images: IMedia[];
  onClosed: () => void;
};

function ProductGallerySwiperLightBox({
  imageSelected,
  images,
  onClosed,
}: ProductGallerySwiperLightBoxProps) {
  // use modal
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [controlledSwiper, setControlledSwiper] = useState<any>();

  const [isReachEnded, setIsReachEnded] = useState<boolean>(false);

  // imageSelected change
  useEffect(() => {
    if (imageSelected) {
      onOpen();

      // find index of imageSelected
      const index = images.findIndex((image) => image.id === imageSelected.id);

      // set swiper to index
      controlledSwiper?.slideTo(index, 0);
    }
  }, [imageSelected, controlledSwiper]);

  // handle modal close
  const handleModalClose = () => {
    onClose();
    onClosed();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleModalClose} size="3xl">
      <ModalOverlay />
      <ModalContent margin="auto" maxWidth="532px" borderRadius="none">
        <ModalBody padding={4} bg="transparent" justifyContent="center">
          <Grid templateColumns="minmax(0, 1fr)">
            <Box position="relative" height="100%">
              <Box height="100%">
                <Swiper
                  spaceBetween={4}
                  slidesPerView={1}
                  resistance={false}
                  onSwiper={(swiper) => setControlledSwiper(swiper)}
                  onReachEnd={() => setIsReachEnded(true)}
                  onReachBeginning={() => setIsReachEnded(false)}
                >
                  {images.map((image, index) => (
                    <SwiperSlide
                      key={index}
                      style={{
                        width: '100%',
                        height: controlledSwiper ? controlledSwiper.size : 400,
                      }}
                    >
                      <Image
                        src={image.url}
                        alt={image.name}
                        width={532}
                        height={532}
                      ></Image>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Box>
              {controlledSwiper ? (
                <>
                  <IconButton
                    position="absolute"
                    left={0}
                    top="50%"
                    transform="translateY(-50%)"
                    fontSize="4xl"
                    colorScheme="primary"
                    variant="link"
                    zIndex="docked"
                    onClick={() => controlledSwiper.slidePrev()}
                    aria-label="Prev"
                    background="rgba(0,0,0, 0.5)"
                    borderRadius="none"
                    minW="auto"
                    w="36px"
                    height="50px"
                    color="white"
                    icon={<LeftOutlined></LeftOutlined>}
                  ></IconButton>
                  <IconButton
                    position="absolute"
                    right={0}
                    top="50%"
                    transform="translateY(-50%)"
                    fontSize="4xl"
                    colorScheme="primary"
                    variant="link"
                    zIndex="docked"
                    onClick={() => controlledSwiper.slideNext()}
                    background="rgba(0,0,0, 0.5)"
                    borderRadius="none"
                    minW="auto"
                    w="36px"
                    height="50px"
                    aria-label="Next"
                    color="white"
                    icon={<RightOutlined></RightOutlined>}
                  ></IconButton>
                </>
              ) : null}
            </Box>
          </Grid>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default ProductGallerySwiperLightBox;
